import SDKConfigurationModel from "../../Configurator/Models/SDKConfiguraitonModel";
import BracketGameFacade from "./Facade/BracketGameFacade";
import BracketGameFilters from "./Models/Filters/BracketGameFilters";
import BracketGamePredictionsFilters from "./Models/Filters/BracketGamePredictionsFilters";
import BracketGameRankingsFilters from "./Models/Filters/BracketGameRankingsFilters";
import BracketGamePredictionRequestBody from "./Models/Prediction/RequestBody/BracketGamePredictionRequestBody";

export default class BracketGame {
  private facade: BracketGameFacade = null;

  constructor(config: SDKConfigurationModel) {
    this.facade = new BracketGameFacade(config);
  }

  public getGames = async (
    filters?: BracketGameFilters | null,
    disableCache?: boolean
  ) => {
    return await this.facade.getGames(filters, disableCache);
  };

  public getGameById = async (gameId: string, disableCache?: boolean) => {
    return await this.facade.getGameById(gameId, disableCache);
  };

  public makePrediction = async (
    gameId: string,
    prediction: BracketGamePredictionRequestBody
  ) => {
    return await this.facade.makePrediction(gameId, prediction);
  };

  public updatePrediction = async (
    gameId: string,
    predictionId: string,
    prediction: BracketGamePredictionRequestBody
  ) => {
    return await this.facade.updatePrediction(gameId, predictionId, prediction);
  };

  public getGamePredictionsForUser = async (
    gameId: string,
    profileId: string,
    filters?: BracketGamePredictionsFilters,
    disableCache?: boolean
  ) => {
    return await this.facade.getGamePredictionsForUser(
      gameId,
      profileId,
      filters,
      disableCache
    );
  };

  public getGamePredictionById = async (
    gameId: string,
    predictionId: string,
    disableCache?: boolean
  ) => {
    return await this.facade.getGamePredictionById(
      gameId,
      predictionId,
      disableCache
    );
  };

  public getRankings = async (
    gameId: string,
    filters?: BracketGameRankingsFilters,
    disableCache?: boolean
  ) => {
    return await this.facade.getRankings(gameId, filters, disableCache);
  };
}
